/*
 * @Author: Ryan
 * @Date: 2026-01-16
 * @Description: Logo 无限滚动组件 - 品牌展示
 */
import Image from 'next/image';
import React from 'react';

import styles from './index.module.scss';

export interface LogoItem {
  id: string;
  src: string;
  alt: string;
  width?: number;
  height?: number;
}

export interface LogoMarqueeProps {
  /** Logo 列表 */
  logos: LogoItem[];
  /** 滚动速度（秒），默认 30 */
  speed?: number;
  /** 滚动方向，默认向左 */
  direction?: 'left' | 'right';
  /** 是否暂停（hover 时） */
  pauseOnHover?: boolean;
  /** 自定义类名 */
  className?: string;
}

const LogoMarquee: React.FC<LogoMarqueeProps> = ({
  logos,
  speed = 30,
  direction = 'left',
  pauseOnHover = true,
  className = '',
}) => {
  if (logos.length === 0) {
    return null;
  }

  // 复制一份用于无缝滚动
  const duplicatedLogos = [...logos, ...logos];

  return (
    <div
      className={`${styles.wrapper} ${pauseOnHover ? styles.pauseOnHover : ''} ${className}`}
      style={
        {
          '--marquee-speed': `${speed}s`,
          '--marquee-direction': direction === 'left' ? 'normal' : 'reverse',
        } as React.CSSProperties
      }
    >
      <div className={styles.track}>
        {duplicatedLogos.map((logo, index) => (
          <div key={`${logo.id}-${index}`} className={styles.logoItem}>
            <Image
              src={logo.src}
              alt={logo.alt}
              width={logo.width || 120}
              height={logo.height || 40}
              className={styles.logoImage}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoMarquee;
